import React from 'react';
import { createRoot } from 'react-dom/client';

import SearchMobile from '@/components/SearchMobile';

export default (lang: string): void => {
  const container = document.getElementById('ssr-search-mobile');

  if (!container) {
    return;
  }

  const root = createRoot(container);

  const placeholder = container
    .querySelector<HTMLInputElement>('input')
    ?.getAttribute('placeholder') ?? '';

  root.render(
    <SearchMobile
      lang={lang}
      placeholder={placeholder}
    />
  );
};
